import * as React from 'react';
import { ErrorBoundary } from '../../utilities/global-error-boundary';
import { ILxsUserRoleData } from './lxs-user-role.data';
import { ILxsUserRoleProps } from './lxs-user-role.props.autogenerated';

export interface ILxsUserRoleViewProps extends ILxsUserRoleProps<ILxsUserRoleData> {}

/**
 *
 * LxsUserRole component
 * @extends {React.PureComponent<ILxsUserRoleProps<ILxsUserRoleData>>}
 */
class LxsUserRole extends React.PureComponent<ILxsUserRoleProps<ILxsUserRoleData>> {
    public render(): JSX.Element | null {
        return null;
    }
}

export default ErrorBoundary(LxsUserRole, 'lxs-user-role');
